<template>
  <StatisticsTemplate>
    <template slot="title"> Access by Model </template>
    <template slot="excel">
      <a
        @click="downExcel()"
        href="javascript:void(0)"
        class="btn btn-secondary btn-md m-1"
        >{{ $t("common.excelDownload") }}</a
      >
    </template>
    <template slot="filter">
      <tr>
        <th>{{ $t("common.period") }}</th>
        <td>
          <date-picker
            v-model="startDate"
            placeholder="Select date"
            @change="selectDate"
            :disabled-date="disabledRange"
          ></date-picker>
          ~
          <date-picker
            v-model="endDate"
            placeholder="Select date"
            @change="selectDate"
            :disabled-date="disabledRange"
          ></date-picker>
        </td>
        <th>Engine Tier</th>
        <td>
          <select
            class="int_type01 mgt_seltype int_w_full selectInput"
            v-model="form.tier"
            @change="setStatistics"
          >
            <option
              v-for="(tier, index) in ecList"
              :key="index"
              v-bind:value="tier.exhaustCertiId"
            >
              {{ tier.exhaustCertiName }}
            </option>
          </select>
        </td>
      </tr>
    </template>
    <template slot="graph">
      <ChartTemplate id="chartTemplate" ref="chartTemplate" />
    </template>
  </StatisticsTemplate>
</template>

<script>
import StatisticsTemplate from "@/components/management/statistics/common/StatisticsTemplate";
import ChartTemplate from "@/components/management/statistics/bymodel/ChartTemplate";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { getEngineTier, accessByModelExcel } from "@/api/statisticsV2";
export default {
  components: {
    ChartTemplate,
    StatisticsTemplate,
    DatePicker,
  },
  data() {
    return {
      startDate: "",
      endDate: new Date(Date.now()),
      form: {
        tier: "",
        startDate: "",
        endDate: "",
      },
      ecList: [],
    };
  },
  async created() {
    await this.setPeriodSelect();
    await this.setTierSelect();
    this.setStatistics();
  },
  methods: {
    setPeriodSelect() {
      var now = new Date();
      var thisYear = now.getFullYear();
      this.startDate = new Date(thisYear + "-01-01 07:00:00");
      this.endDate = new Date(Date.now());
      this.setDateFormat();
    },
    disabledRange(date) {
      return date < new Date("2020", "12", "01") || date > new Date(Date.now());
    },
    setDateFormat() {
      let startTmpYear = this.startDate.getFullYear();
      let startTmpMonth = this.startDate.getMonth() + 1;
      let startTmpDate = this.startDate.getDate();
      let startResult =
        startTmpYear +
        "" +
        (startTmpMonth.toString().length == 1 ? "0" + startTmpMonth : startTmpMonth) +
        "" +
        (startTmpDate.toString().length == 1 ? "0" + startTmpDate : startTmpDate);

      let endTmpYear = this.endDate.getFullYear();
      let endTmpMonth = this.endDate.getMonth() + 1;
      let endTmpDate = this.endDate.getDate();
      let endResult =
        endTmpYear +
        "" +
        (endTmpMonth.toString().length == 1 ? "0" + endTmpMonth : endTmpMonth) +
        "" +
        (endTmpDate.toString().length == 1 ? "0" + endTmpDate : endTmpDate);
      this.form.startDate = startResult;
      this.form.endDate = endResult;
    },
    selectDate() {
      if (this.startDate > this.endDate) {
        alert(this.$t("alert.checkDate"));
        this.endDate = this.startDate;
        return;
      }
      this.setDateFormat();
      this.setStatistics();
    },
    async setTierSelect() {
      let result = await getEngineTier();
      this.ecList = result.data.ecList;
      this.form.tier = this.ecList[0].exhaustCertiId;
    },
    async setStatistics() {
      await this.$refs.chartTemplate.getData(
        this.form.startDate,
        this.form.endDate,
        this.form.tier
      );
    },
    async downExcel() {
      let loader = this.$loading.show({});
      let result = await accessByModelExcel(
        this.form.startDate,
        this.form.endDate,
        this.form.tier
      );
      // exhaustCertiName 할당
      let tierName = this.form.tier;
      for (let i in this.ecList) {
        if (this.ecList[i].exhaustCertiId == this.form.tier) {
          tierName = this.ecList[i].exhaustCertiName;
        }
      }
      const url = window.URL.createObjectURL(
        new Blob([result.data], { type: result.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "AccessByModel_" + tierName + ".xls";
      link.click();
      window.URL.revokeObjectURL(url);
      loader.hide();
    },
  },
};
</script>

<style></style>
